import classnames from 'classnames'
import PropTypes from 'prop-types'

import './statBox.scss'

const StatBox = ({boxStyle, className, dataTestid, label, stat}) => (
  <div
    className={classnames('stat-box', className)}
    data-testid={dataTestid}>
    <div className={classnames('box', boxStyle)}>
      <div className='stat'>{stat}</div>
      <div className='label'>{label}</div>
    </div>
  </div>
)

StatBox.propTypes = {
  boxStyle: PropTypes.oneOf([
    'active-box',
    'black-box',
    'pending-box',
    'purple-box'
  ]),
  className: PropTypes.string,
  dataTestid: PropTypes.string,
  label: PropTypes.string,
  stat: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
}

export default StatBox
